const path = require('path');

const stackOutputDepth = 5; // 栈输出深度

module.exports = (errorStack) => {
  const serverRootPath = ''; // 设置为空没影响
  // 在该函数里，固定调用层数为3
  const callDepth = 3;
  const fileNameDepth = serverRootPath.split('/').length;
  const rootPath = serverRootPath
    .split('/')
    .slice(1, fileNameDepth - 1)
    .join('/');

  const { stack = '' } = errorStack;
  const stackInfo = stack.split('\n').slice(callDepth, callDepth + stackOutputDepth);

  const [file] = stackInfo;
  // file example is at Object.<anonymous> (/Users/corbinlee/qcintl/qcloud-intl/server/startup/worker.js:15:8)
  const line = file.split('/').slice(1)
    .join('/')
    .replace(rootPath, '');

  const [module] = line.split(':');
  const [index] = file.split(path.join(__dirname, '../'))[0].split('/');

  return {
    index,
    module,
    line,
    stackInfo: stackInfo.join('\n'),
  };
};
